import React from 'react';
import { FormattedMessage } from 'react-intl';
import floorplan from '../../../assets/images/floorplan.png';

const Floorplan = () => {
  return (
    <div>
      <h2 className="ui header">
        <FormattedMessage
          id="floorplan"
          description="Floorplan menu item"
        />
      </h2>
      <div className="ui grid">
        <div className="center aligned row">
          <div className="column">
            <a href="http://floorplan.futurecom.com.br">
              <img src={floorplan} className="ui image" alt="Agenda" />
            </a>
            <h2 className="ui header">
              <FormattedMessage
                id="floorplanText"
                description="Floorplan text"
              />
            </h2>
            <a
              href="http://floorplan.futurecom.com.br"
              className="ui big blue header"
            >
              floorplan.futurecom.com.br
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Floorplan;



/** WEBPACK FOOTER **
 ** ./src/components/screens/floorplan/Floorplan.js
 **/